import styled from 'styled-components'

export const OtherOptionInputContainer = styled.div`
  div {
    margin-bottom: 5px;
  }
`

export const OtherOptionLengthDisplay = styled.div`
  display: flex;
  justify-content: flex-end;

  p {
    color: #898989;
  }
`
